module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp/img_webinar_06-2ff98c7f35d25836a27eb5783783578f.png";